import {useState, useEffect, useRef} from 'react';
// import { ReactComponent as ArrowSVG } from 'assets/icon-arrow-right.svg';
// import { ReactComponent as InfoSVG } from 'assets/icon-info.svg';
import { ReactComponent as SortSVG } from 'assets/icon-sort.svg';
import {
  // Link,
  useLocation } from 'react-router-dom';
import styles from './index.module.scss';
// import { format } from 'date-fns';
import { useAuth } from 'context/Auth';
import { listUserCoupons, UserCouponsData } from 'api/logs';
import { sendFmeClaimGuide } from 'api/fmeReturnship';
import liff from '@line/liff';
import { LINE_OFFICIAL_URL } from 'constants/externalLinks';
import {
  checkPendingCouponClaim,
  bindUserRentLog,
  PendingCouponClaimCoupon,
} from 'api/return';
import { useNavigate } from 'react-router';
import { useGlobalError } from 'context/Error/GlobalErrorContext';
import NonPic from 'assets/nonPic.png';
import CouponPicker from 'components/CouponPicker';
import Dialog from 'components/Dialog';
import { resolveImageUrl } from 'utils/imageUrl';

// momo 事後綁定 localStorage TTL（7 天）
const PENDING_CLAIM_TTL_MS = 7 * 24 * 3600 * 1000;
// 全家歸還的確認畫面樣式(內聯:這頁沒有自己的 module.scss,不為一個畫面新增檔案)
const famiGuideWrap: React.CSSProperties = {
  minHeight: '100vh',
  background: '#f5f7f6',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: 20,
};
const famiGuideCard: React.CSSProperties = {
  background: '#fff',
  borderRadius: 16,
  padding: '32px 24px',
  maxWidth: 340,
  width: '100%',
  textAlign: 'center',
  boxShadow: '0 2px 12px rgba(0,0,0,.08)',
};
const famiGuideIcon: React.CSSProperties = { fontSize: 44, lineHeight: 1, marginBottom: 12 };
const famiGuideTitle: React.CSSProperties = { fontSize: 20, fontWeight: 700, margin: '0 0 12px', color: '#111' };
const famiGuideText: React.CSSProperties = { fontSize: 14, lineHeight: 1.8, color: '#555', margin: '0 0 24px' };
const famiGuideBtn: React.CSSProperties = {
  width: '100%',
  padding: '14px 0',
  border: 'none',
  borderRadius: 10,
  background: '#00CC89',
  color: '#fff',
  fontSize: 16,
  fontWeight: 700,
};

const PENDING_CLAIM_KEY = 'pending_coupon_claim';

interface PendingClaimStorage {
  // PG-56 新版後端:改存 claim_token(uuid 字串)
  user_rent_log_id: string;
  created_at: number;
}


const OnlineDiscount = () => {
  const [filter, setFilter] = useState<'all' | 'useable' | 'expired'>('useable');
  const [sort, setSort] = useState<'ascend' | 'descend'>('descend');
  const { accessToken, me } = useAuth();
  const [coupons, setCoupons] = useState<UserCouponsData[]>();
  const [pendingCoupons, setPendingCoupons] = useState<PendingCouponClaimCoupon[]>([]);
  const pendingRentLogIdRef = useRef<string | null>(null);
  // 領取成功後的提示彈窗
  const [claimSuccessVisible, setClaimSuccessVisible] = useState<boolean>(false);
  // 全家歸還按「領取優惠券」進來時蓋在最上層的說明畫面(見下方 fetchPendingClaim)
  const [famiGuideVisible, setFamiGuideVisible] = useState<boolean>(false);
  // 還沒加官方帳號好友的人收不到推播(LINE 不允許推給非好友),要引導他加
  const [needAddFriend, setNeedAddFriend] = useState<boolean>(false);
  const [claimedCount, setClaimedCount] = useState<number>(0);
  const { pathname } = useLocation();
  const { showError } = useGlobalError()
  const filterRef = useRef<string>('useable');
  const sortRef = useRef<string>('descend');
  const navigate = useNavigate();


  useEffect(() => {
    // PG-92: 等 accessToken ready 才呼叫,避免 LIFF 初始化時 token 還沒到位就 early-return,
    // 之後 effect 不會再跑造成「歸還優惠券可領取」banner 永遠不顯示 (Lynn 04/29 momo 流程回報)。
    if (!accessToken) return;
    fetchCoupons();
    checkPendingClaim();
    // eslint-disable-next-line
  }, [pathname, accessToken]);

  const fetchCoupons = async () => {
    setCoupons([]);
    try {
      const { data } = await listUserCoupons(accessToken!, 1, me?.id!,
      filterRef.current, sortRef.current);
      if (!data) {
        return 'Have not any Coupons !!';
      } else {
        setCoupons(data);
      }
    } catch (e: any) {
      console.log(e);
      showError(e, 'error')
    }
  };

  /**
   * 檢查是否有「歸還過但未領券」的狀態。
   * 1) 先讀 localStorage（momo 匿名歸還後保留的 pending_coupon_claim）
   * 2) 若沒有 / 已過期 → 不帶 user_rent_log_id 呼叫後端，讓後端查登入會員最近一筆未領 log
   * 3) 後端回 claimable=true → 顯示可領清單
   */
  const checkPendingClaim = async () => {
    if (!accessToken) return;

    // PG-56 新版後端:改用 claim_token(uuid 字串)
    let pendingId: string | null = null;

    // PG-92 r3: 優先讀 URL query (?user_rent_log_id=X)。
    // momo 歸還在 Safari 完成後,使用者切到 LINE 點圖文選單進 LIFF webview,
    // localStorage 不互通會讀不到;ReturnCompleteDialog 改用 LIFF URL query 直接帶過來。
    try {
      const fromUrl = new URLSearchParams(window.location.search).get('user_rent_log_id');
      if (fromUrl) {
        pendingId = fromUrl;
      }
    } catch (e) {
      // ignore
    }

    // 2) URL 沒帶 → 讀 localStorage(同 webview 內歸還流程,例如 LINE 內走完整套)
    if (!pendingId) {
      try {
        const raw = localStorage.getItem(PENDING_CLAIM_KEY);
        if (raw) {
          const pending: PendingClaimStorage | null = JSON.parse(raw);
          if (pending && pending.user_rent_log_id) {
            if (Date.now() - pending.created_at <= PENDING_CLAIM_TTL_MS) {
              pendingId = pending.user_rent_log_id;
            } else {
              localStorage.removeItem(PENDING_CLAIM_KEY);
            }
          }
        }
      } catch (e) {
        localStorage.removeItem(PENDING_CLAIM_KEY);
      }
    }

    // 會員登入狀態掃碼歸還時,return.tsx 存進來的是數字歸還單 id,不是 claim token。
    // 送去綁定端點只會 422,而且 localStorage 7 天不清,推播進來領券的會員按幾次都失敗。
    // 會員的歸還本來就綁在自己身上,不需要 token,直接當「沒有」即可,領券會用最近一筆歸還。
    if (pendingId && pendingId.length !== 36) {
      try {
        localStorage.removeItem(PENDING_CLAIM_KEY);
      } catch (e) {
        // ignore
      }
      pendingId = null;
    }

    // 先把這筆歸還綁回登入的會員(不領任何券)。
    //
    // 原本綁定只發生在「按下領取」那一刻,但全家歸還要等日翊回報交件才給券 ——
    // 券還沒出現時使用者按不到領取,歸還就永遠停在匿名狀態,交件回拋進來時
    // 既沒有推播對象、也判斷不出該不該發券給誰。使用者點進這頁就是要身分了,
    // 在這裡先綁起來才接得上後面的流程。
    if (pendingId) {
      let isFami = false;
      try {
        isFami = new URLSearchParams(window.location.search).get('fami') === '1';
      } catch (e) {
        // ignore
      }
      try {
        await bindUserRentLog(accessToken, [pendingId], []);
        // 全家歸還:綁定完成後請後端推 Step 1 引導訊息(momo/其他通路後端會自行略過)。
        // pendingId 就是 claim_token(PG-56 之後這個欄位存的是 uuid)。
        await sendFmeClaimGuide({ claimToken: pendingId });
      } catch (e) {
        // 綁不起來不擋畫面:可能已綁給別人,下面 checkPendingCouponClaim 會給正確結果
        console.log('bindUserRentLog (bind only) failed', e);
      }
      // 全家:券要等交件確認才有,直接把券清單丟給使用者只會看到「已領過的券」而困惑。
      // 原本做成自動關窗,實測是「券頁閃一秒又跳回上一頁」,看起來像壞掉(同仁回報)。
      // 改成顯示一張明確的確認畫面,由使用者自己按鈕回 LINE。
      if (isFami) {
        // LINE 規定不能推播給非好友 —— 沒加好友的人會看到「已傳送到您的 LINE」卻收不到訊息。
        // 先問好友狀態,不是好友就把畫面換成引導加好友。
        try {
          const fs = await liff.getFriendship();
          setNeedAddFriend(!fs?.friendFlag);
        } catch (e) {
          // 問不到就當作已是好友,不要因此擋住流程
          setNeedAddFriend(false);
        }
        setFamiGuideVisible(true);
      }
    }

    // 2) 呼叫後端（有帶 id 驗證該筆；沒帶則讓後端找登入者最近一筆未領 log）
    try {
      const { data } = await checkPendingCouponClaim(accessToken, pendingId ?? undefined);
      if (data?.claimable) {
        pendingRentLogIdRef.current = pendingId;
        setPendingCoupons(data.coupons || []);
      } else {
        // 不可領（已綁定他人 / 已領過）→ 清掉本地 state + localStorage
        localStorage.removeItem(PENDING_CLAIM_KEY);
        pendingRentLogIdRef.current = null;
        setPendingCoupons([]);
      }
    } catch (e: any) {
      console.log(e);
    }
  };

  const handleClaimPending = async (selectedIds: number[]) => {
    if (!accessToken) return;
    try {
      // 沒有 claim token 也要能領:從官方帳號通知 / 圖文選單直接進來的會員沒有 token,
      // 後端會用本人最近一筆已歸還紀錄領(對齊舊站 checkPendingCouponClaim 由伺服器找最近一筆)。
      // 原本這裡直接 return,使用者看得到券卻按了沒反應。
      const tokens = pendingRentLogIdRef.current ? [pendingRentLogIdRef.current] : [];
      await bindUserRentLog(accessToken, tokens, selectedIds);
      localStorage.removeItem(PENDING_CLAIM_KEY);
      pendingRentLogIdRef.current = null;
      setPendingCoupons([]);
      setClaimedCount(selectedIds.length);
      setClaimSuccessVisible(true);
      // 重新抓取，剛領到的券會出現在下方已擁有清單
      fetchCoupons();
    } catch (e: any) {
      console.log(e);
      showError(e, 'error');
    }
  };
  
  if (famiGuideVisible) {
    return (
      <div style={famiGuideWrap}>
        <div style={famiGuideCard}>
          <div style={famiGuideIcon}>{needAddFriend ? '💬' : '✅'}</div>
          <h2 style={famiGuideTitle}>
            {needAddFriend ? '請先加入官方 LINE' : '感謝您參與歸還'}
          </h2>
          {needAddFriend ? (
            <p style={famiGuideText}>
              優惠券的領取通知會透過配客嘉官方 LINE 發送,
              <br />
              請先加入好友才收得到喔!
              <br />
              <br />
              請記得將循環包裝帶到全家門市完成歸還,
              <br />
              門市接收後約 2-3 個工作天確認,
              <br />
              確認完成我們會通知您回來領取優惠券。
            </p>
          ) : (
            <p style={famiGuideText}>
              請記得將循環包裝帶到全家門市完成歸還。
              <br />
              目前尚未顯示優惠券是正常的喔!
              <br />
              門市接收包裝後,系統約需 2-3 個工作天確認;
              <br />
              確認完成時,我們會再透過 LINE 通知您回來領取優惠券。
            </p>
          )}
          <button
            type="button"
            style={famiGuideBtn}
            onClick={() => {
              // closeWindow() 只在 LIFF 開啟的視窗有效;從一般網址進來的情境呼叫它
              // 會關不掉,畫面就停在白底(同仁回報「按了跳白畫面」)。
              // 因此無論如何都排一個導向官方帳號的退路,關得掉的話會先關、走不到這行。
              setTimeout(() => {
                window.location.href = LINE_OFFICIAL_URL;
              }, 300);
              try {
                if (liff.isInClient && liff.isInClient()) {
                  liff.closeWindow();
                }
              } catch (e) {
                // 關不掉就讓上面的 setTimeout 帶他回官方帳號
              }
            }}
          >
            {needAddFriend ? '加入官方 LINE 好友' : '回到 LINE'}
          </button>
        </div>
      </div>
    );
  }

  return (
    <>
      {pendingCoupons.length > 0 && (
        <div style={{ padding: '12px 16px', background: '#fff8e1', borderBottom: '1px solid #f0d070', marginBottom: 8 }}>
          <h5 style={{ margin: '0 0 8px', fontSize: 14, color: '#303030' }}>
            歸還優惠券可領取
          </h5>
          <CouponPicker
            coupons={pendingCoupons}
            confirmText="領取"
            onConfirm={handleClaimPending}
          />
        </div>
      )}
      <div className={styles.toolbar}>
        <div className={styles.filters}>
          <button
            className={filter === 'all' ? styles.active : undefined}
            onClick={() => {
              setFilter('all');
              filterRef.current = 'all';
              fetchCoupons();
            }}
          >
            全部
          </button>
          <button
            className={filter === 'useable' ? styles.active : undefined}
            onClick={() => {
              setFilter('useable');
              filterRef.current = 'useable';
              fetchCoupons();
            }}
          >
            可使用
          </button>
          <button
            className={filter === 'expired' ? styles.active : undefined}
            onClick={() => {
              setFilter('expired');
              filterRef.current = 'expired';
              fetchCoupons();
            }}
          >
            已逾期
          </button>
        </div>
        <div className={styles.sort}>
          <button
            onClick={() => {
              setSort(sort === 'ascend' ? 'descend' : 'ascend');
              sortRef.current = sort === 'ascend' ? 'descend' : 'ascend';
              fetchCoupons();
            }}
          >
            {sort === 'descend' ? '最新' : '最舊'}
            <SortSVG />
          </button>
        </div>
      </div>
      <div className={styles.list}>
        {coupons && coupons.length === 0 && (
          <div style={{ padding: '40px 16px', textAlign: 'center', color: '#9a9a9a', fontSize: 14, lineHeight: 1.7 }}>
            目前沒有{filter === 'useable' ? '可使用' : filter === 'expired' ? '已逾期' : ''}的優惠券
            <br />
            完成循環包裝歸還即可領取
          </div>
        )}
        {coupons?.map((item) => (
          <div key={item.id} className={styles.listItem}>
            <div className={styles.shadow}></div>
            {/* <img src={item.picture_url} alt="" className={styles.img} /> */}
            <img
              src={resolveImageUrl(item.picture_url) || NonPic}
              onError={(e) => {
                // imgur 相簿網址這類不是圖檔的連結會破圖,退回預設圖
                if (!e.currentTarget.src.endsWith(NonPic)) e.currentTarget.src = NonPic;
              }}
              alt=""
              className={styles.img}
            />
            <div className={styles.info}>
              <h5>{item.title}</h5>
              <div className={styles.date}>
                <span>
                  {/* {item.start_at?.slice(0,10)} ~ {item.expired_at?.slice(0,10)} */}
                  {item.created_at?.slice(0,10)}
                </span>
              </div>
            </div>
            <div className={styles.btnContainer}>
              <button
                onClick={() => {
                  // 一碼一券同一張券可以領好幾次(每次歸還一組序號),只帶 coupon_id 會永遠打開第一組,
                  // 補上領取時間讓詳情頁認得是哪一次領的
                  navigate(`./detail/${item.coupon_id}?claimed_at=${encodeURIComponent(item.created_at)}`);
                }}
              >詳情
              </button>
            </div>
          </div>
        ))}
    </div>

    <Dialog
      visible={claimSuccessVisible}
      onConfirm={() => {
        // PG-91: 領取成功後留在優惠券列表頁,讓使用者立刻在下方清單看到剛領的券。
        // 舊版 navigate('/rent') 會把使用者踢回首頁,Lynn 04/29 回報。
        setClaimSuccessVisible(false);
      }}
      showOk={false}
      message={
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 12,
            padding: '12px 8px 4px',
          }}
        >
          <h5 style={{ margin: 0, color: '#3db270', fontSize: 18, fontWeight: 700 }}>
            領取成功 🎉
          </h5>
          <p style={{ margin: 0, fontSize: 14, color: '#303030', textAlign: 'center', lineHeight: 1.6 }}>
            已成功領取 {claimedCount} 張優惠券
            <br />
            可在下方清單查看
          </p>
          <p style={{ margin: 0, fontSize: 12, color: '#9a9a9a', textAlign: 'center', lineHeight: 1.5 }}>
            下次歸還循環包裝後<br />可再次領取新的優惠券
          </p>
          <button
            type="button"
            onClick={() => {
              setClaimSuccessVisible(false);
            }}
            style={{
              width: 160,
              height: 42,
              background: '#3db270',
              border: '1px solid #303030',
              borderRadius: 6,
              boxShadow: '6px 8px 0px #00000029',
              color: '#ffffff',
              fontSize: 16,
              fontWeight: 700,
              cursor: 'pointer',
              marginTop: 6,
            }}
          >
            知道了
          </button>
        </div>
      }
    />
    </>
  );

};

export default OnlineDiscount;
